import { render, staticRenderFns } from "./sidebar_footer.vue?vue&type=template&id=d841ddfe&"
import script from "./sidebar_footer.vue?vue&type=script&lang=ts&"
export * from "./sidebar_footer.vue?vue&type=script&lang=ts&"
import style0 from "./sidebar_footer.vue?vue&type=style&index=0&id=d841ddfe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports